import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'reactstrap';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { DateTime } from 'luxon';

import { createForm } from '../../../models/Form';
import globalTranslations from '../../../i18n/globalTranslations';
import { isDate, notBlank } from '../../../util/formValidators';
import FormGroupField from '../../form/FormGroupField';
import { createFormField } from '../../../models/FormField';

const labels = {
  startDate: <FormattedMessage {...globalTranslations.startDateTitle} />,
  endDate: <FormattedMessage {...globalTranslations.endDateTitle} />,
};

@observer
class PurchaseReportForm extends Component {
  form = null;
  formName = 'PurchaseReportForm';

  constructor(props) {
    super(props);

    this.form = createForm({
      startDate: createFormField(
        {
          value: props.initialStartDate
            ? props.initialStartDate
            : DateTime.local().startOf('month').toISODate(),
        },
        [notBlank(labels.startDate), isDate(labels.startDate)]
      ),
      endDate: createFormField(
        {
          value: props.initialEndDate
            ? props.initialEndDate
            : DateTime.local().endOf('month').toISODate(),
        },
        [notBlank(labels.endDate), isDate(labels.endDate)]
      ),
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.form.validate();
    if (this.form.valid && this.props.onSubmit) {
      this.props.onSubmit(this.form.getFieldValues());
    }
  };

  date = (fieldName) => {
    const field = this.form.fields.get(fieldName);
    return (
      field.active && (
        <div className="PurchaseReportForm__field">
          <FormGroupField
            field={field}
            type="date"
            required={true}
            formName={this.formName}
            fieldName={fieldName}
            label={labels[fieldName]}
          />
        </div>
      )
    );
  };

  render() {
    return (
      <Form className={this.formName} onSubmit={this.handleSubmit}>
        <div className="PurchaseReportForm__row">
          {this.date('startDate')}
          {this.date('endDate')}
          <div className="PurchaseReportForm__submit">
            <Button
              color="primary"
              disabled={this.form.valid === false || this.props.disableSubmit}
            >
              <FormattedMessage
                id="customerUser.fetchPurchases"
                defaultMessage="Fetch purchases"
              />
            </Button>
          </div>
        </div>
      </Form>
    );
  }
}

PurchaseReportForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disableSubmit: PropTypes.bool,
  initialStartDate: PropTypes.string,
  initialEndDate: PropTypes.string,
};

export default PurchaseReportForm;
